import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
    #root {
        white-space: pre-wrap;
    }
`

export default GlobalStyle
